import * as React from 'react';
import {StyleSheet, Text, TextStyle, View, ViewStyle} from 'react-native';

import CheckCircleIcon from '../../../shared/icons/CheckCircleIcon';
import PrimaryButton from '../../../shared/buttons/PrimaryButton';

interface Props {
  newScene: boolean;
  onPress: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
}

const SceneSubmitButton: React.FunctionComponent<Props> = props => {
  const {newScene, disabled, onPress} = props;
  return (
    <PrimaryButton
      buttonSize={buttonSize}
      unwrappedText={true}
      disabled={disabled}
      onPress={onPress}>
      <View style={styles.icon}>
        <CheckCircleIcon color={'white'} size={25} />
      </View>
      <Text style={styles.text}>{`シーンを${newScene ? '登録' : '更新'}`}</Text>
    </PrimaryButton>
  );
};

export default React.memo(SceneSubmitButton);

const buttonSize = {
  width: 168,
  height: 46,
};

const styles = StyleSheet.create({
  icon: {
    marginHorizontal: 6,
  } as ViewStyle,
  text: {
    color: 'white',
    fontSize: 15,
    fontWeight: 'bold',
  } as TextStyle,
});
